import axios from 'axios'
export const LOAD_PAIRS = 'load_pairs';
export const LOAD_PERFORMACE = 'load_performance';
export const LOAD_PERFORMACE_DATES = 'load_performance_dates';
export const SET_FUND = 'set_fund';
export const SET_BMK = 'set_bmk';
export const SET_DATE = 'set_date';
export const SET_CATEGORY = 'set_category';
export const SET_PERIOD = 'set_period';
export const SET_SORT = 'set_sort';
export const SORT_DATA = 'sort_data';
export const SET_CURRENT_URL = 'set_current_url';
export const LOAD_PERFORMACE_DATES_URL = 'load_performance_dates_url';


export function loadPairs() {
  return (dispatch, getState) => {
    const request = {
      method: 'GET',
      url: `${process.env.REACT_APP_API_URL}/fundattribution/pairs/`
    };
    return axios(request)
      .then(response => {
        dispatch({ type: LOAD_PAIRS, payload: response.data });
        var idx = window.location.search.split('fund=')[1] || '';
        if (idx !== '') {
          dispatch(setFund(idx));
        }
      })
      .catch(error => {
        console.log(error)
      });
  }
}

export function loadPerformance() {
  return (dispatch, getState) => {
    let params = {
      fund: getState().performance.fund,
      bmk: getState().performance.bmk,
      curr_date: getState().performance.date
    };
    if (window.perfattr) {
      if (window.perfattr.clientEmail) {
        params.email = window.perfattr.clientEmail;
      }
      if (window.perfattr.wtRegion) {
        params.wtRegion = window.perfattr.wtRegion;
      }
    }

    const request = {
      method: 'GET',
      url: `${process.env.REACT_APP_API_URL}/fundattribution/attribution/`,
      params: params
    };
    return axios(request)
      .then(response => {
        dispatch({ type: LOAD_PERFORMACE, payload: response.data });
        dispatch({ type: SORT_DATA });
      })
      .catch(error => {
        console.log(error)
      });
  }
}

// loads the fund details excel
export function loadAttributionExcel() {
  return (dispatch, getState) => {
    let params = {
      fund: getState().performance.fund,
      bmk: getState().performance.bmk,
      curr_date: getState().performance.date
    };
    const request = {
      method: 'GET',
      responseType: 'blob',
      url: `${process.env.REACT_APP_API_URL}/fundattribution/excel/`,
      params: params
    };
    return axios(request)
      .then(response => {
        const fileName = `Attribution-${getState().performance.fund}-${getState().performance.bmk}.xlsx`;
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          a.click();
        }
      })
      .catch(error => {
        console.log(error)
      });
  }
}

export function loadPerformanceDates(fromUrl = false) {
  return (dispatch, getState) => {
    const request = {
      method: 'GET',
      url: `${process.env.REACT_APP_API_URL}/fundattribution/dates/`,
      params: {
        fund: getState().performance.fund,
        bmk: getState().performance.bmk,
      }
    };
    return axios(request)
      .then(response => {
        if (fromUrl) {
          dispatch({ type: LOAD_PERFORMACE_DATES_URL, payload: response.data });
        } else {
          dispatch({ type: LOAD_PERFORMACE_DATES, payload: response.data });
        }
        dispatch(loadPerformance());
        dispatch(updateQueryParams());
      })
      .catch(error => {
        console.log(error)
      });
  }
}

export function setFund(idx) {
  return (dispatch, getState) => {
    dispatch({ type: SET_FUND, payload: idx });
    dispatch(loadPerformanceDates());
    dispatch(updateQueryParams());
    dispatch(saveToGA('Analyze'));
  }
}

export function setBmk(pair) {
  return (dispatch, getState) => {
    dispatch({ type: SET_BMK, payload: pair });
    dispatch(loadPerformanceDates());
    dispatch(updateQueryParams());
    dispatch(saveToGA('Analyze'));
  }
}

export function setDate(date) {
  return (dispatch, getState) => {
    dispatch({ type: SET_DATE, payload: date });
    dispatch(updateQueryParams());
    dispatch(loadPerformance());
  }
}

export function setCategory(cat) {
  return (dispatch, getState) => {
    dispatch({ type: SET_CATEGORY, payload: cat });
    dispatch({ type: SORT_DATA });
    dispatch(updateQueryParams());
    dispatch(saveToGA(cat));
  }
}

export function setPeriod(period) {
  return (dispatch, getState) => {
    dispatch({ type: SET_PERIOD, payload: period });
    dispatch({ type: SORT_DATA });
    dispatch(updateQueryParams());
  }
}

export function setSort(column) {
  return (dispatch, getState) => {
    dispatch({ type: SET_SORT, column: column });
    dispatch({ type: SORT_DATA });
  }
}

// Save the run of loaded funds to GA
export function saveToGA(eventAction) {
  return (dispatch, getState) => {
    const e = {
      'eventName': 'fund attribution',
      'eventAction': eventAction,
      'eventLabel': `${getState().performance.fund}_${getState().performance.bmk}`,
      'type': 'CustomTagEvent'
    };

    if (window.digitalData) {
      if (e.Label !== '') {
        window.digitalData.newEvent(e);
        console.log('digitalData: ', e);
      }
    } else {
      console.log('no digitalData: ', e);
    }
  }
}

export function updateQueryParams() {
  return (dispatch, getState) => {
    if (getState().performance.data) {
      const fund = getState().performance.fund;
      const bmk = getState().performance.bmk;
      let date = getState().performance.date;
      const period = getState().performance.period;
      const category = getState().performance.category;
      let newHash = `#fund-attribution&fund=${fund}&bmk=${bmk}&urlDate=${date}&urlCategory=${category}&urlPeriod=${period}`;
      window.history.replaceState(null, null, newHash);
      dispatch({ type: SET_CURRENT_URL, payload: window.location.origin + window.location.pathname + newHash });
    }
  }
}

export function loadFromUrl(fund, bmk, date, category, period) {
  return (dispatch, getState) => {
    dispatch({ type: SET_FUND, payload: fund });
    dispatch({ type: SET_BMK, payload: bmk });
    dispatch({ type: SET_DATE, payload: date });
    dispatch({ type: SET_CATEGORY, payload: category });
    dispatch({ type: SET_PERIOD, payload: period });
    dispatch(loadPerformanceDates(true));
  }
}


// WEBPACK FOOTER //
// ./src/actions/index.js